module.exports.call_user_func = require('./call_user_func')
module.exports.call_user_func_array = require('./call_user_func_array')
module.exports.create_function = require('./create_function')
module.exports.function_exists = require('./function_exists')
module.exports.get_defined_functions = require('./get_defined_functions')
